import "@/assets/css/style.scss";

import { createApp } from 'vue'
import App from './App.vue'
const Application = window.Application = createApp(App);

Application
    .mount('#app');

